import React from "react";

import LinearProgress from "@mui/material/LinearProgress";

interface propsTypes {
  color?: any;
  variants?: any;
  marginBottom?: string;
  height?: string;
}

const CardLinearProgress = (props: propsTypes) => {
  let height = props.height;
  let marginBottom = props.marginBottom;

  return (
    <div>
      <LinearProgress
        color={props.color}
        variant={props.variants}
        sx={{ height: height, marginBottom: marginBottom }}
      />
    </div>
  );
};

export default CardLinearProgress;
